import React from 'react';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';

require('./infoChart.scss');

export default class InfoChart extends React.PureComponent {
  render() {
    let {text, count, totalCount} = this.props.data.toObject();
    let {className} = this.props;
    return (
      <section className={classNames('right-top-component-container', className)}>
        <div className="count">{count}</div>
        { totalCount !== undefined ? <div className="separator"></div> : " "}
        <div className="inner-text-count">
          { totalCount !== undefined ? <span>{totalCount} </span> : null}

          <FormattedMessage id={text} defaultMessage="x_infochart" />

        </div>
      </section>
    );
  }
}


